import * as types from "./mutationTypes";

export default {
  [types.SET_IP](state, ip) {
    state.ip = ip;
  },
  [types.CLEAR_IP](state) {
    state.ip = null;
  },
  [types.SET_IPS](state, ips) {
    state.ips = ips;
  },
  [types.CLEAR_IPS](state) {
    state.ips = null;
  },
  [types.SET_REMOVED_IPS](state, removedIps) {
    state.removedIps = removedIps;
  },
  [types.CLEAR_REMOVED_IPS](state) {
    state.removedIps = null;
  },
  [types.ADD_IP](state) {
    state.ips.push({ uuid: null, ip: state.ip });
    state.ip = null;
  },
  [types.REMOVE_IP](state, selectedIP) {
    if (selectedIP.uuid !== null) {
      state.removedIps.push(selectedIP);
    }
    state.ips = state.ips.filter((ip) => ip.ip !== selectedIP.ip);
  }
};
